export default __webpack_public_path__ + "static/media/outdoor.184a13ae.xlsm";